import React from "react";
import PropTypes from "prop-types";
import { ErrorContainer, ErrorLink } from "./styled";

/**
 * Component to display document upload error messages with try again option
 *
 * @component
 */
export const DocumentUploadError = ({
  error = "Oops! We couldn't upload the document.",
  tryAgainHandler = () => {},
  tryAgain = true
}) => {
  return (
    <ErrorContainer>
      {error}.
      {tryAgain && (
        <>
          Please
          <ErrorLink onClick={tryAgainHandler}>try again.</ErrorLink>
        </>
      )}
    </ErrorContainer>
  );
};

/**
 * PropTypes for DocumentUploadError component
 */
DocumentUploadError.propTypes = {
  /**
   * Error message to display
   */
  error: PropTypes.string,

  /**
   * Handler function for try again action
   */
  tryAgainHandler: PropTypes.func,

  /**
   * Whether to show the try again option
   */
  tryAgain: PropTypes.bool
};
